/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Options_Watermark_Save_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update watermark settings: {error}" |
*
* @param {Options_Watermark_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_save_failed_toast = /** @type {((inputs: Options_Watermark_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la mise à jour des paramètres du filigrane : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Wasserzeichen-Einstellungen konnten nicht aktualisiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiornare le impostazioni della filigrana: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обновить настройки водяного знака: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron actualizar los ajustes de marca de agua: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更新水印设置失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ウォーターマークの設定を更新できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वॉटरमार्क सेटिंग्स अपडेट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao atualizar as definições de marca de água: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update watermark settings: ${i?.error}`)
});